import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _get from 'lodash/get';
import _some from 'lodash/some';

export const filterLandingFeaturedResources = (
  resources,
  insuranceTags,
  state,
) => {
  const insuranceTagsIds = insuranceTags.map(tag => tag.id);
  return resources
    .filter(resource => {
      const hasStateSet =
        Boolean(state) && !_isEmpty(_get(resource, 'fields.state'));

      if (!hasStateSet) return true;

      return _get(resource, 'fields.state').includes(state);
    })
    .filter(resource => {
      if (_isNil(resource)) return false;
      if (
        !_isEmpty(_get(resource, 'requiredTagsCollection.items', [])) &&
        !_some(_get(resource, 'requiredTagsCollection.items', []), tag =>
          insuranceTagsIds.includes(_get(tag, 'sys.id')),
        )
      ) {
        return false;
      }
      return true;
    });
};
